// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"85ecdae0","239":"9a793878","455":"11420526"}[chunkId] + ".chunk.js";
};